import { useCallback } from 'react'

import {
  Award,
  EventData,
  EventType,
  EventStatus,
  REWARD_FEATURE,
  REWARD_EVENT,
} from '~/gamification/types/gamification.types'
import { ChampionshipStoryCardId, StoryCardId } from '~/types/storyCard'
import { CHAMPIONSHIP_IDS } from '~/types/homebaseQuiz.types'

import { useUpdateEventDataMutation } from '~/redux/apis/reward-api'

interface CompletePetEventOptions {
  mathEnergyOrbs?: number
}

export function useCompletePetEvent(id: StoryCardId): any {
  const [updateEventsData] = useUpdateEventDataMutation()
  return useCallback(
    (options?: CompletePetEventOptions) =>
      updateEventsData([{ id, type: EventType.PET, status: EventStatus.COMPLETED, ...options }]),
    [id, updateEventsData],
  )
}

export function useCompleteChampionshipEvent(id: CHAMPIONSHIP_IDS): any {
  const [updateEventsData] = useUpdateEventDataMutation()
  return useCallback(
    (award: Award) =>
      updateEventsData([
        {
          id,
          type: EventType.CHAMPIONSHIP,
          status: EventStatus.COMPLETED,
          award,
          eventFeature: REWARD_FEATURE.CHAMPIONSHIP,
          eventType: REWARD_EVENT.REWARDS,
        },
      ]),
    [id, updateEventsData],
  )
}

export function selectChampionshipStoryCardEventId(data: EventData): ChampionshipStoryCardId {
  if (data.id === CHAMPIONSHIP_IDS.CHAMPIONSHIP_2021 && data.award === Award.FIRST) {
    return ChampionshipStoryCardId.TimesTableCompetition2021FirstPlace
  }
  if (data.id === CHAMPIONSHIP_IDS.CHAMPIONSHIP_2021 && data.award === Award.SECOND) {
    return ChampionshipStoryCardId.TimesTableCompetition2021SecondPlace
  }
  if (data.id === CHAMPIONSHIP_IDS.CHAMPIONSHIP_2021 && data.award === Award.THIRD) {
    return ChampionshipStoryCardId.TimesTableCompetition2021ThirdPlace
  }
  return ChampionshipStoryCardId.TimesTableCompetition2021Participant
}
